import React from "react";
import "../index.css"; 

const Certifications = () => {
  return (
    <section id="certifications" className="py-3"> 
      <div className="container">
        <h2 className="fw-bold mb-4">Certifications</h2>

        {/* First Journey */}

        <div className="mb-4">
          <div className="d-flex">
            <div className="line me-4 border-bottom border-5"></div> {/* Add the line here */}
            <div className="w-100">
              <div className="d-flex justify-content-between align-items-center">
                {/* <h3 className="fw-bold">Certifications</h3> */}
                {/* <p className="fw-bold job-date">August 2022</p> */}
              </div>
              {/* <p className="company-link">
                <a
                  href="https://skillrazr.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="company-link-text"
                >
                  at, University of London - International Programme, United Kingdom
                </a>
              </p> */}
             {/* <h6 className="fw-bold">•	Skills and Technicals Used:
                </h6> */}
                <ul className="mt-3">
                  <li><strong>Bloomberg Market Certificate (BMC):</strong> Expertise in analyzing market functions and economic systems using Bloomberg Terminal.
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
